
//STYLES
import { Card } from "./style";

//APP
import { leadZero } from "../../../../../../../../utils";

//PROPS
interface Props {
    title: string;
    value: string | number;
    type: string;
    icon: string;
    title_size: number;
    color?: 'default' | 'red' | 'yellow' | 'green';
    onClick: Function;
};

export const CardDetalhe: React.FC<Props> = ({ title, value, type, icon, title_size, onClick, color }) => {

    function sizeValue(): number {
        if (type === 'number') {
            return undefined;
        }
        let qtd_char = String(value).length;
        return 35 - (qtd_char * 1.4);
    }

    return (
        <Card
            whileHover={{ scale: 1.05, opacity: 1 }}
            whileTap={{ scale: 0.95 }}
            data-color={color}
            onClick={() => onClick?.()}
            style={{ cursor: onClick ? 'pointer' : 'not-allowed', opacity: Number(value) === 0 ? 0.3 : 1 }}
        >
            <p className="Card__title" style={{ fontSize: title_size }}>{title}</p>
            <p className="Card__value" style={{ fontSize: sizeValue() }}>
                {type === 'number' ? leadZero(value) : value}
            </p>

            <img src={icon} className="Card__icon" />
        </Card>
    )
}